import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { companyInfo, whatsappNumber, whatsappMessage } from '../../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <header className={`header-nav ${isScrolled ? 'scrolled' : ''}`}>
      <div className="flex items-center">
        <img 
          src={companyInfo.logo} 
          alt={companyInfo.name} 
          style={{ width: '160px', height: 'auto', minHeight: '40px' }}
          className="object-contain"
        />
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center gap-8">
        <button 
          onClick={() => scrollToSection('beneficios')}
          className="text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors font-medium"
        >
          Benefícios
        </button>
        <button 
          onClick={() => scrollToSection('faq')}
          className="text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors font-medium"
        >
          FAQ
        </button>
        <a 
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-whatsapp"
        >
          Falar no WhatsApp
        </a>
      </nav>

      {/* Mobile Menu Button */}
      <button 
        className="md:hidden p-2"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Menu"
      >
        {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="absolute top-full left-0 right-0 shadow-lg md:hidden border-t border-[var(--border-light)]" style={{ background: 'var(--bg-card)' }}>
          <nav className="flex flex-col p-4 gap-4">
            <button 
              onClick={() => scrollToSection('beneficios')}
              className="text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors font-medium text-left py-2"
            >
              Benefícios
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors font-medium text-left py-2"
            >
              FAQ
            </button>
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp mt-2"
            >
              Falar no WhatsApp
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
